import type { V2AdminDemoFirstRunStatusDto } from '@idc-forms/api-client'
import { RotateCcw } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@/shared/ui/alert-dialog'
import { Button } from '@/shared/ui/button'
import { firstRunStatusLine } from '../models/demo-first-run'

type CardViewProps = {
  /** Sin estado no hay tarjeta: es la compuerta (el servidor responde 404 a quien no la ve). */
  status: V2AdminDemoFirstRunStatusDto | undefined
  isResetting: boolean
  confirmOpen: boolean
  onConfirmOpenChange: (open: boolean) => void
  onReset: () => void
}

/** La parte visual, sin hooks, para poder probar la compuerta y el texto. */
export function ClientAccountDemoFirstRunCardView({
  status,
  isResetting,
  confirmOpen,
  onConfirmOpenChange,
  onReset
}: CardViewProps) {
  if (!status) return null

  return (
    <div className="flex flex-col gap-2 rounded-md border bg-secondary/50 p-3 dark:bg-accent/40">
      <div className="flex flex-col gap-0.5">
        <p className="text-sm font-medium">Cuenta de revisión de tiendas</p>
        <p className="text-xs text-muted-foreground">{firstRunStatusLine(status)}</p>
      </div>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="self-start"
        disabled={isResetting}
        onClick={() => {
          onConfirmOpenChange(true)
        }}
      >
        <RotateCcw className="h-4 w-4" />
        Dejar como nueva
      </Button>

      <AlertDialog open={confirmOpen} onOpenChange={onConfirmOpenChange}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>¿Dejar esta cuenta como nueva?</AlertDialogTitle>
            <AlertDialogDescription>
              Esto es lo que va a pasar: se elimina la aceptación de los términos (queda una copia
              en la bitácora de seguridad), se cierran todas las sesiones, así que el teléfono
              pedirá iniciar sesión de nuevo, y los avisos push se apagan y las preferencias vuelven
              a sus valores por defecto. En el próximo ingreso se mostrarán los términos, la oferta
              de Face ID y el paso de notificaciones.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction
              onClick={() => {
                onReset()
                onConfirmOpenChange(false)
              }}
            >
              Dejar como nueva
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  )
}
